import { HttpErrorResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
// @ts-ignore Ignore unused commented imports
import { CoreActions } from '@next/core-lib';
import { NotificationActions } from '@next/core-lib/notification';
import { ofType, createEffect, Actions } from '@ngrx/effects';

// @ts-ignore Ignore unused commented ActionTypes import
import { Action, Store } from '@ngrx/store';

import { Observable, of } from 'rxjs';
import { mergeMap, catchError, map, startWith, finalize } from 'rxjs/operators';
import { SiteState } from 'src/app/shared/models/siteState.model';

import { DevAuthService } from '../../services/dev-auth.service';
import * as devAuthActions from '../actions/dev-auth-actions';

@Injectable()
export class DevAuthEffects {
  devAuthRequest$: Observable<Action> = createEffect(() =>
    this.actions$.pipe(
      ofType(devAuthActions.sendAuthenticatedRequest),
      mergeMap((request) =>
        this.api.httpGetDevAuthRequest(request).pipe(
          map((response) => devAuthActions.sendAuthenticatedRequestSuccess({ response })),
          catchError((error: HttpErrorResponse) =>
            of(NotificationActions.errorSnackbar({ message: error.message })),
          ),
          startWith(CoreActions.setLoading({ loading: true })),
          finalize(() => this.store.dispatch(CoreActions.setLoading({ loading: false }))),
        ),
      ),
    ),
  );

  constructor(
    private readonly actions$: Actions,
    private readonly api: DevAuthService,
    private store: Store<SiteState>,
  ) {}
}
